import { 
    GROUPS_REGISTER_INITIAL_USER_DATA, 
    GROUPS_REGISTER_USER_LOCATION, 
    GROUPS_REGISTER_USER_DESCRIBE_YOURSELF, 
    GROUPS_REGISTER_USER_LANGUAGE, 
    GROUPS_REGISTER_EXISTING_USER_DATA, 
    GROUPS_REGISTER_SET_AVAILALE_GROUPS, 
    GROUPS_REGISTER_USER_GENERAL_SKILL_LEVEL 
} from '../../constants';

import { fromJS } from 'immutable';
import { IGroupsRegisterUserData } from '../../components/models/models';

const INITIAL_STATE = fromJS({
    groupsRegisterData: {
        groupsRegisterUserData: {

        }
    }
});

function groupsRegisterReducer(state = INITIAL_STATE, action =
    {
        type: '',
        groupsRegisterUserData: null,
        groupsRegisterLocationData: null,
        groupsRegisterDescribeYourselfData: null,
        groupsRegisterGeneralSkillLevelData: null,
        groupsRegisterLanguageData: null,
        groupsRegisterExistingUserData: null,
        groupsRegisterAvailableGroupsData: null,
    }) {


    switch (action.type) {

        case GROUPS_REGISTER_EXISTING_USER_DATA:
            let prevUserData = state.get('groupsRegisterData').get("groupsRegisterUserData").toJS();

            let newUserData: IGroupsRegisterUserData = {
                ...prevUserData,
                location: action.groupsRegisterExistingUserData.location,
                locationText: action.groupsRegisterExistingUserData.locationText,
                describeYourself: action.groupsRegisterExistingUserData.describeYourself,
                generalSkillLevel: action.groupsRegisterExistingUserData.generalSkillLevel || "Beginner",
                language: action.groupsRegisterExistingUserData.language,
            }

            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    groupsRegisterUserData: newUserData,
                })),
            }));

        case GROUPS_REGISTER_INITIAL_USER_DATA:
            prevUserData = state.get('groupsRegisterData').get("groupsRegisterUserData").toJS();

            newUserData = {
                ...prevUserData,
                userId: action.groupsRegisterUserData.userId,
                firstName: action.groupsRegisterUserData.firstName,
                lastName: action.groupsRegisterUserData.lastName,
                email: action.groupsRegisterUserData.email,
            }

            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    groupsRegisterUserData: newUserData,
                })),
            }));

        case GROUPS_REGISTER_USER_LOCATION:
            prevUserData = state.get('groupsRegisterData').get("groupsRegisterUserData").toJS();

            newUserData = {
                ...prevUserData,
                location: action.groupsRegisterLocationData.location,
                locationText: action.groupsRegisterLocationData.locationText,
            }

            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    groupsRegisterUserData: newUserData,
                })),
            }));

        case GROUPS_REGISTER_USER_DESCRIBE_YOURSELF:
            prevUserData = state.get('groupsRegisterData').get("groupsRegisterUserData").toJS();
            newUserData = {
                ...prevUserData,
                describeYourself: action.groupsRegisterDescribeYourselfData.describeYourself,
            }

            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    groupsRegisterUserData: newUserData,
                })),
            }));

        case GROUPS_REGISTER_USER_GENERAL_SKILL_LEVEL:
            prevUserData = state.get('groupsRegisterData').get("groupsRegisterUserData").toJS();
            newUserData = {
                ...prevUserData,
                generalSkillLevel: action.groupsRegisterGeneralSkillLevelData.generalSkillLevel,
            }

            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    groupsRegisterUserData: newUserData,
                })),
            }));

        case GROUPS_REGISTER_USER_LANGUAGE:
            prevUserData = state.get('groupsRegisterData').get("groupsRegisterUserData").toJS();

            newUserData = {
                ...prevUserData,
                language: action.groupsRegisterLanguageData.language,
            }

            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    groupsRegisterUserData: newUserData,
                })),
            }));

        case GROUPS_REGISTER_SET_AVAILALE_GROUPS:
            return state.merge(fromJS({
                groupsRegisterData: state.get('groupsRegisterData').merge(fromJS({
                    availableGroups: action.groupsRegisterAvailableGroupsData.availableGroups,
                })),
            }));

        default:
            return state;
    }
}

export default groupsRegisterReducer;
